import { FileAddOutlined } from '@ant-design/icons';
import { WidgetCategory, WidgetMainType, tran } from '@framework/engine';
import { IWidgetType } from '@framework/engine/src/schema/widgets/IWidgetType';

import React from 'react';
import {
  IModuleTriggerWidget,
  WidgetModuleTriggerType,
} from './IModuleTriggerWidget';
import { ModuleTriggerConfigComponent as ModuleTriggerWidgetConfigComponent } from './ModuleTriggerConfigComponent';
import { ModuleTriggerConfigSchema } from './ModuleTriggerConfigSchema';
import { ModuleTriggerPreviewComponent } from './ModuleTriggerPreviewComponent';
import { ModuleTriggerWidgetComponent } from './ModuleTriggerWidgetComponent';
import { createModuleTriggerFormSchema } from './createModuleTriggerFormSchema';

declare module '@framework/engine/src/schema/widgets/Widget' {
  export enum WidgetType {
    ModuleTrigger = 'moduleManager',
  }
}

export const TriggerModuleMetaKey = 'triggeredModule' as const;

/**
 * Widget di tipo "Attiva modulo".
 */
export const ModuleTriggerWidgetType: IWidgetType<IModuleTriggerWidget> = {
  type: WidgetModuleTriggerType,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Advanced,
  name: 'Attivazione moduli',
  icon: <FileAddOutlined />,
  formComponent: ModuleTriggerWidgetComponent,
  createFormSchema: createModuleTriggerFormSchema,
  previewComponent: ModuleTriggerPreviewComponent,
  configValidator: ModuleTriggerConfigSchema,
  configComponent: ModuleTriggerWidgetConfigComponent,
  configOptions: {
    removeCollapsePanel: true,
    hideDirectives: true,
  },
  hideFlags: true,
  translationSchema: tran.widget({}),
  rules: [],
  hasValue: false,
};
